define(function (require, exports, module) {
    var ContentTV = require('./ContentTV');
    var FEEDTYPE_FILTER = {
        home: true,
        away: true,
        national: true
    };

    function ContentTVList (mlbtv) {
        this.parseData(mlbtv);
    }

    ContentTVList.prototype = {
        parseData: function (tv) {
            if (tv) {
                var i = 0;
                var len = tv.length;
                var list = this.list = [];
                var lang = this.language = {};
                var id = this.id = {};
                var guid = this.guid = {};
                var media;

                for (; i < len; i++) {
                    media = new ContentTV(tv[i]);
                    if (FEEDTYPE_FILTER[media.mediaFeedTypeKey]) {
                        (lang[media.language] = lang[media.language] || []).push(media);
                        (id[media.id] = lang[media.id] || []).push(media);
                        (guid[media.guid] = guid[media.guid] || []).push(media);
                        list.push(media);
                    }
                }
            }
        }
    };

    return ContentTVList;
});
